import { render, staticRenderFns } from "./VPlacementsTable.vue?vue&type=template&id=0345b852"
import script from "./VPlacementsTable.vue?vue&type=script&lang=js"
export * from "./VPlacementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports